module.exports = __webpack_public_path__ + "static/media/lochs.a78a51fd.jpg";